import * as React from 'react';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import ConfigUtility from '../../Core/ConfigUtility';
import LogrocketFuzzySanitizer from 'logrocket-fuzzy-search-sanitizer';

const Config = ConfigUtility.getSync()!;
export const LOGROCKET_IGNORE_CLASS = '_lr-hide';
export interface Props {
  children?: React.ReactNode;
}

export interface State {}

export default class LogRocketErrorMonitor extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    ConfigUtility.get().then(x => {
      if (x.LogRocket.Enabled) {
        // Enable request data sanitization
        const { requestSanitizer, responseSanitizer } = LogrocketFuzzySanitizer.setup(
          x.LogRocket.FilteredWords
        );

        LogRocket.init(x.LogRocket.AppName, {
          network: {
            requestSanitizer,
            responseSanitizer,
          },
        });
        setupLogRocketReact(LogRocket);
      }
    });
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}
